export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  quote: string;
}

export interface Milestone {
  time: string;
  title: string;
  desc: string;
}

export const principles: Principle[] = [
  {
    icon: "ri-file-shield-2-line",
    title: "只做公开信息梳理",
    desc: "所有内容都基于已经公开的信息进行现象层面的整理，不发布未经证实的指控，也不对个人做主观定性。",
  },
  {
    icon: "ri-time-line",
    title: "按时间线组织",
    desc: "同一话题的来龙去脉按发生顺序排列，让读者能看清前因后果，而不是只看到被截取的一个片段。",
  },
  {
    icon: "ri-scales-3-line",
    title: "表达保持克制",
    desc: "不用夸张标题博取点击，不放大对立情绪，把讨论留在内容本身，让回顾真正有参考价值。",
  },
  {
    icon: "ri-book-open-line",
    title: "存档长期有效",
    desc: "往期文章不做删除，只在时间线上持续沉淀。话题有了新的公开进展时，我们会以补充说明的方式更新。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿柚",
    role: "追综艺多年的老观众",
    quote: "最舒服的一点是它不急着下结论，而是把事情按时间排好，我自己看完就能判断，比刷零散片段清楚多了。",
  },
  {
    name: "林一",
    role: "影评爱好者",
    quote: "口碑反转那一篇分析得很实在，从预期管理讲到节奏问题，看完对追剧的耐心都变好了。",
  },
  {
    name: "小满",
    role: "内容从业者",
    quote: "把行业现象拆得挺清楚，尤其是探店降温那段，几乎是把我工作里的困惑直接写出来了。",
  },
  {
    name: "周周",
    role: "泛娱乐内容读者",
    quote: "栏目分类做得好，想专门翻某一类旧料的时候不用一页页找，搜索也准。",
  },
];

export const milestones: Milestone[] = [
  {
    time: "起点",
    title: "从一份个人整理的话题清单开始",
    desc: "最初只是把零散的热点按时间记下来，方便自己回看。后来发现同样的整理方式，对很多读者也有用。",
  },
  {
    time: "成型",
    title: "建立六个常设栏目",
    desc: "把内容拆成综艺、影视、创作者、造型、行业与网络热议六个方向，让不同兴趣的读者都能快速定位。",
  },
  {
    time: "沉淀",
    title: "从单篇观察转向存档体系",
    desc: "开始为每篇内容标注时间、栏目与关键词，并建立可在站内检索的存档结构。",
  },
  {
    time: "现在",
    title: "把「可回顾」当作第一目标",
    desc: "内容的价值不只在于发布当天的热度，更在于几个月后是否还值得被翻出来重看。",
  },
];